import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { catchAsync, FormField, IS_SUCCESS_RESPONSE } from "src/helpers";
import {
  INITIAL_SCHEDULE_CALL_FORM_VALUES,
  SCHEDULE_CALL_FORM_FIELDS,
  SCHEDULE_CALL_FORM_VALIDATION_SCHEMA,
} from "./modules";
import RenderFormComponents from "src/shadcn/components/custom/RenderFormComponents";
import { Button } from "src/shadcn/components/ui";
import { createScheduleCallbackApiRequest } from "src/services/requests/ScheduleCall";
import LoadingDialog from "src/shadcn/components/custom/LoadingDialog";
import CustomeDialog from "src/shadcn/components/custom/CustomeDialog";
import { useLocation, useNavigate } from "react-router-dom";

const ScheduleCallForm = () => {
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);
  const [subscribedData, setSubscribData] = useState<any>({});
  const { search } = useLocation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: INITIAL_SCHEDULE_CALL_FORM_VALUES,
    validationSchema: SCHEDULE_CALL_FORM_VALIDATION_SCHEMA,
    onSubmit(values, formikHelpers) {
      const { phonenumber, ...val } = values;
      const postdata = {
        ...val,
        phonenumber: String(phonenumber),
        // email:subscribedData?.email,
        // campaign_name:subscribedData?.campaign_name,
        medium: "EMAIL",
      };
      handleRequest(postdata);
    },
  });

  useEffect(() => {
    const params = search && search?.split("?")[1].split("&");

    let searchParams: any = {};

    params &&
      params.forEach((o: any) => {
        let splitParam = o?.split("=");
        searchParams[splitParam[0]] = splitParam[1];
      });
    setSubscribData(searchParams && searchParams);
    //   setMonthFilter(searchParams?.month);
    //   setActivity(searchParams?.activity);

    return () => {};
  }, [search]);

  const handleRequest = catchAsync(
    async (postdata: any) => {
      setisLoading(true);
      return await createScheduleCallbackApiRequest(postdata, subscribedData);
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setIsOpenSuccessDialog(true);
        setisLoading(false);
      }
    },
    () => {
      setisLoading(false);
    }
  );

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {SCHEDULE_CALL_FORM_FIELDS.map((field: FormField) => {
          return (
            <div>
              <RenderFormComponents
                key={`new-schedule-meet-form-${field.dataKey}`}
                formik={formik}
                value={formik.values[field.dataKey as keyof object]}
                {...field}
                onChange={(e: any) => formik.setFieldValue(field.dataKey, e)}
              />
            </div>
          );
        })}
        <div className="flex justify-center py-4">
          <Button isLoading={isLoading} className="w-[150px]">
            Submit
          </Button>
        </div>
      </form>
      <LoadingDialog isOpen={isLoading} />
      <CustomeDialog
        isOpen={isOpenSuccessDialog}
        headerTitle={"Request Sent"}
        hideDefaultCancle
        onSubmit={() => navigate("/")}
      >
        <p className="mb-2">Your call scheduled, We will contact you soon.</p>
      </CustomeDialog>
    </>
  );
};

export default ScheduleCallForm;
